module.exports = __webpack_public_path__ + "static/9stream-0b845fcf3c990ea2d96612d2a8736d50.jpg";